var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 17.123 3.711 21.497 8.23 23.218C8.12 22.281 8.003 20.736 8.255 19.652C8.472 18.72 9.656 13.714 9.656 13.714C9.656 13.714 9.299 12.999 9.299 11.94C9.299 10.28 10.261 9.04 11.46 9.04C12.48 9.04 12.972 9.805 12.972 10.722C12.972 11.747 12.319 13.279 11.982 14.7C11.701 15.889 12.579 16.859 13.751 16.859C15.874 16.859 17.507 14.62 17.507 11.388C17.507 8.527 15.451 6.528 12.516 6.528C9.118 6.528 7.123 9.077 7.123 11.712C7.123 12.739 7.518 13.839 8.012 14.438C8.05412 14.4832 8.08387 14.5386 8.09841 14.5986C8.11295 14.6587 8.11177 14.7215 8.095 14.781C8.004 15.159 7.802 15.97 7.763 16.136C7.71 16.354 7.59 16.401 7.363 16.295C5.871 15.601 4.939 13.42 4.939 11.668C4.939 7.899 7.676 4.439 12.831 4.439C16.975 4.439 20.196 7.392 20.196 11.338C20.196 15.455 17.601 18.769 13.997 18.769C12.786 18.769 11.649 18.139 11.259 17.396C11.259 17.396 10.66 19.678 10.515 20.236C10.233 21.32 9.451 22.692 8.966 23.471C10.084 23.815 11.27 24 12.5 24C19.127 24 24.5 18.627 24.5 12C24.5 5.373 19.127 0 12.5 0C5.873 0 0.5 5.373 0.5 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPinterest);
export default __webpack_public_path__ + "static/media/social-pinterest.80c0eb0e7c0ea6a3e18a49033cf5dd7f.svg";
export { ForwardRef as ReactComponent };